import { createContext, useContext } from 'react';
import { MidwayUser } from '../utils/midway';

export interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: MidwayUser | null;
  error: string | null;
}

export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  isLoading: true,
  user: null,
  error: null,
});

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
